/**
 *
 *
 * @author Ivan Shchedrovskyi
 */
export const ReservationTabError = () => {
	return <div>{'error'}</div>
}
